export const FIXED = { value: "FIXED", key: "admin.guarantees.types.fixed" };
export const PRICE_LIST = {
  value: "PRICE_LIST",
  key: "admin.guarantees.types.list",
};
export const FORMULA = {
  value: "FORMULA",
  key: "admin.guarantees.types.formula",
};
export const MEMBER = { value: "MEMBER", key: "admin.guarantees.types.member" };

export const MEMBER_MULTIPLIER = {value: "MEMBER_MULTIPLIER", key: "admin.guarantees.types.memberMultiplier"};

export default [FIXED, PRICE_LIST, FORMULA, MEMBER, MEMBER_MULTIPLIER];



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/guarantees/enums/guaranteeTypes.js